export type CsvPropertyData = Indexable<string>;

export const CsvSelectOne = '-- select one --';

export enum CsvBool {
  Empty = '-- select one --',
  Yes   = 'Yes',
  No    = 'No',
}
